import { ReactNode, useEffect, useState } from "react";
import classNames from "classnames";

import styles from "./sceneLoop.module.scss";

interface SceneLoopProps {
  scenes: ReactNode[];
  intervalMs?: number;
}

// Plays each scene in turn (for example: where the control is, then how it behaves).
const SceneLoop = ({ scenes, intervalMs = 5200 }: SceneLoopProps) => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (scenes.length < 2) return;
    const id = window.setInterval(
      () => setIndex((i) => (i + 1) % scenes.length),
      intervalMs,
    );
    return () => window.clearInterval(id);
  }, [scenes.length, intervalMs]);

  return (
    <div className={styles.loop}>
      <div key={index} className={styles.frame}>
        {scenes[index]}
      </div>
      {scenes.length > 1 && (
        <div className={styles.dots} aria-hidden="true">
          {scenes.map((_, i) => (
            <span
              key={i}
              className={classNames(styles.dot, {
                [styles.dotActive]: i === index,
              })}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default SceneLoop;
